import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CoreStore } from "@modules/+new/core/core-store/domain/entities/core-store.model";
import { CoreStoreStateService } from "@modules/+new/core/core-store/domain/+state/core-store.state.service";

@Injectable({
	providedIn: "root"
})
export class CoreStoreFacade {
	public readonly coreStore$: Observable<CoreStore> = this.state.getCoreStore$();

	// TODO temp, used as static data in "legacy" services, to remove after refactor this "legacy" services
	public get coreStoreSnapshot(): CoreStore {
		return this.state.getCoreStoreSnapshot();
	}

	public constructor(private readonly state: CoreStoreStateService) {}

	public increaseRequestCounter(): void {
		this.state.increaseRequestCounter();
	}

	public decreaseRequestCounter(): void {
		this.state.decreaseRequestCounter();
	}

	public updateLogoutState(isLogout: boolean): void {
		this.state.updateLogoutState(isLogout);
	}

	public updateOfflineState(isOffline: boolean): void {
		this.state.updateOfflineState(isOffline);
	}

	public updateAccessToken(accessToken: string): void {
		this.state.updateAccessToken(accessToken);
	}

	public clearAccessToken(): void {
		this.state.clearAccessToken();
	}

	public getAccessToken(): string {
		return this.state.getAccessToken();
	}

	public hasAccessToken(): boolean {
		return this.state.hasAccessToken();
	}
}
